import React, { Component } from 'react';
import './styles.scss';
import { connect } from 'react-redux';
import { simpleAction } from '../../core/actions/homeAction';
import { withTranslation } from "react-i18next";
import { Button, Form, Message } from 'semantic-ui-react';
import { compose } from 'redux';

import { importFileAction } from "../../core/actions/commonAction";

class UploadFile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            file: null,
            error: false
        };
    }

    fileInputRef = React.createRef();

    onFormSubmit = e => {
        e.preventDefault(); // Stop form submit
        let fileName = this.state.file ? this.state.file : "";
        this.fileUpload(fileName);
    };

    onChange = (e) => {
        // console.log(functionCommon.checkfile(e.target.files[0]));
        this.setState({ file: e.target.files[0], error: false }, () => {
            console.log("File chosen --->", this.state.file);
        });
    }

    // Import datasources/schemas Tab 1
    fileUpload = file => {
        const fileUpload = file;
        if(file.size / 1024 / 1024 < 2 ) {

            this.props.importFileAction(
                {
                    urlGetkey: "project/requestSecretKey",
                    urlDownfile: "project/projectImport"
                },
                fileUpload
            );
        } else {
            this.setState({ error: true });
        }
    };

    render() {
        const { file, error } = this.state;
        let fileName = file ? file.name : "Choose File";
        return (
            <Form onSubmit={this.onFormSubmit} error>
               <Button
                    content={fileName}
                    labelPosition="left"
                    icon="file"
                    type="reset"
                    onClick={() => this.fileInputRef.current.click()}
                />
                <input
                    ref={this.fileInputRef}
                    type="file"
                    hidden
                    onChange={(e) => this.onChange(e)}
                    accept=".xlsx, .xls, .csv, .xlsm"
                />
                <Button type="submit">Upload</Button>
                {error &&
                    <Message
                        error
                        header=''
                        content='Upload 3M thoyyy nhaa'
                    />
                }
            </Form>
        );
    }
}

const mapStateToProps = state => ({
    ...state,
})

const mapDispatchToProps = dispatch => ({
    simpleAction: () => dispatch(simpleAction()),
    importFileAction: (url, param) => dispatch(importFileAction(url, param)),
})

export default compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(UploadFile);
